import React, { useEffect, useState } from 'react';
import Loader from '../../../components/Loader/Loader';
import '../TruNorthDashboard/TruNorthDashboard.less';
import { formatUrl, handleZoom } from '../../../libs/helper/HelperFunctions';
import {
  IVisitedPagePayload,
  SectionType,
  TrafficAnalyticsActions,
} from '../../../libs/store/actions/WebAnalytics/TrafficAnalyticsActions';
import { useDispatch } from 'react-redux';
import { CBOKeyAssets } from '../../CBOSidebar/CBOSidebarConstants';
import { IProduct } from '../../../libs/models/cbo/EngagementModels';
import { IApplicationState, useAppSelector } from '../../../libs/store/reducers';

interface IAssetProps {
  selectedAssetConfig?: IProduct;
  isEngagement?: boolean;
  selectedEnagagementName?: string;
  selectedEnagagementId?: string;
  selectedClientName?: string;
}

const SMART_DQ_ASSET_NAME = CBOKeyAssets.smartDataQuality;

const SmartDQDashboard = ({
  isEngagement,
  selectedAssetConfig,
  selectedEnagagementName,
  selectedEnagagementId,
  selectedClientName,
}: IAssetProps) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  const dispatcher = {
    postPageVisited: (data: IVisitedPagePayload) =>
      dispatch(TrafficAnalyticsActions.postVisitedPageStart(data)),
  };

  const { KeyAssetDefaultList } = useAppSelector((state: IApplicationState) => ({
    KeyAssetDefaultList: state.engagement.KeyAssetDefaultList,
  }));

  const selectedAssetConfigDefault = KeyAssetDefaultList?.find(
    (keyAsset) => keyAsset.product?.toLowerCase() === selectedAssetConfig?.product?.toLowerCase(),
  );

  useEffect(() => {
    handleZoom('assess-iframe');
    dispatcher.postPageVisited({
      sectionType: isEngagement ? SectionType.ENG_ASSET : SectionType.PURSUIT_ASSET,
      assetName: SMART_DQ_ASSET_NAME,
      name: selectedEnagagementName,
      id: selectedEnagagementId,
      clientName: selectedClientName,
    });

    return () => {
      dispatcher.postPageVisited({
        sectionType: isEngagement ? SectionType.ENG_ASSET : SectionType.PURSUIT_ASSET,
        assetName: SMART_DQ_ASSET_NAME,
        name: selectedEnagagementName,
        id: selectedEnagagementId,
        clientName: selectedClientName,
      });
    };
  }, []);

  const getIframeUrl = (instanceUrl?: string) => {
    return `${formatUrl(instanceUrl ?? '')}`;
  };

  return (
    <div className="trunorth-dashboard-wrapper">
      <Loader loaderName="Authorizing..." loading={isLoading}>
        <iframe
          id="smartdq"
          className="assess-iframe"
          title={SMART_DQ_ASSET_NAME}
          src={
            isEngagement
              ? getIframeUrl(selectedAssetConfig?.instanceUrl)
              : selectedAssetConfig?.configDone
                ? getIframeUrl(selectedAssetConfig?.instanceUrl)
                : getIframeUrl(selectedAssetConfigDefault?.instanceUrl)
          }
          onLoad={() => setIsLoading(false)}
        />
      </Loader>
    </div>
  );
};

export default SmartDQDashboard;
